{
  "version": 1,
  "asset_id": "144a8b4a-d240-4596-ba9f-b0c1d624d104",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/144a8b4a-d240-4596-ba9f-b0c1d624d104/hiatal-type-iv-upper-gi-en-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/144a8b4a-d240-4596-ba9f-b0c1d624d104/hiatal-type-iv-upper-gi-en-480.webp",
  "original_filename": "hiatal-type-iv-upper-gi-en-480.webp",
  "size": 19592,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:55:26Z"
}
